import axios from '@/libs/api.request'

export const createCustomerBomFile = ({ bomId, fileId, headerRowIndex }) => {
  return axios.request({
    url: '/bom/customer-file/create',
    data: {
      bom_id: bomId,
      file_id: fileId,
      header_row_index: headerRowIndex
    },
    method: 'post'
  })
}

export const getCustomerBomFile = (customerBomFileId) => {
  return axios.request({
    url: `/bom/customer-file/${customerBomFileId}`,
    method: 'get'
  })
}

export const updateCustomerBomFile = ({ id, header_mapping }) => {
  return axios.request({
    url: `/bom/customer-file/${id}`,
    method: 'put',
    data: {
      header_mapping
    }
  })
}

export const saveCustomerBomFileTree = ({ id, data }) => {
  return axios.request({
    url: `/bom/customer-file/${id}/rows/build-tree`,
    method: 'post',
    data: { data: data }
  })
}

export const saveCustomerBomFileData = ({ id, data }) => {
  return axios.request({
    url: `/bom/customer-file/${id}/rows`,
    method: 'post',
    data: {
      rows: data
    }
  })
}

export const finishCustomerBomFileTree = (fileId) => {
  return axios.request({
    url: `/bom/customer-file/${fileId}/submit`,
    method: 'post'
  })
}

export const getCustomerBomFileWithVersion = ({ fileId, version }) => {
  return axios.request({
    url: `/bom/customer-file/${fileId}/compare/${version}`,
    method: 'get'
  })
}
